import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import currency from "currency.js";

import { DeleteIcon } from "../Icons";

const WarehouseIssueItemModalTable = (props) => {
  const [showInput, setShowInput] = useState(false);
  const [inputValue, setInputValue] = useState(0);

  const update = (e, inx) => {
    if (e.key === "Enter") {
      if (inputValue === "" || parseFloat(inputValue) < 1)
        return toast.error(`Quantity can not be empty or less than one`);

      setShowInput(false);
      props.updateQuantity(inputValue, inx);
    }
  };

  //   console.log(props.el);

  useEffect(() => {
    setInputValue(props.el.qty);
  }, [props.el.qty]);

  return (
    <tr>
      {props?.serialNum && <td>{props?.el?.serialNum}</td>}
      <td>{props.el.itemId}</td>
      <td onClick={() => setShowInput(false)}>{props.el.itemName}</td>
      <td onClick={() => setShowInput(true)}>
        {showInput ? (
          <input
            type="number"
            className="inputTable"
            value={inputValue}
            onChange={(e) => !props?.serialNum && setInputValue(e.target.value)}
            onKeyDown={(e) => !props?.serialNum && update(e, props.index)}
          />
        ) : (
          props.el.qty
        )}
      </td>
      <td onClick={() => setShowInput(false)}>
        {currency(props.el.costPrice, {
          symbol: "",
        }).format()}
      </td>
      <td>
        {currency(props.el.subtotal, {
          symbol: "",
        }).format()}
        <span
          className="mx-3 p-cursor"
          onClick={() => props.deleteItem(props.index)}
        >
          {/* <DeleteIcon color="#FF0000" width="14" height="14" /> */}
          <DeleteIcon width="14" height="14" />
        </span>
      </td>
    </tr>
  );
};

export default WarehouseIssueItemModalTable;
